import React from 'react';
import {
    OptionShimmer,
    CircleShimmer,
    IconShimmer,
    DetailShimmer,
    TitleShimmer,
    DescriptionShimmer,
    WrapperShimmer,
    Shimmer
} from './styled';

export const TypeOperationRadioInputShimmer: React.FC = () => (
    <WrapperShimmer>
        <OptionShimmer>
            <CircleShimmer><Shimmer /></CircleShimmer>
            <IconShimmer><Shimmer /></IconShimmer>
            <DetailShimmer>
                <TitleShimmer><Shimmer /></TitleShimmer>
                <DescriptionShimmer><Shimmer /></DescriptionShimmer>
            </DetailShimmer>
        </OptionShimmer>
        <OptionShimmer>
            <CircleShimmer><Shimmer /></CircleShimmer>
            <IconShimmer><Shimmer /></IconShimmer>
            <DetailShimmer>
                <TitleShimmer><Shimmer /></TitleShimmer>
                <DescriptionShimmer><Shimmer /></DescriptionShimmer>
            </DetailShimmer>
        </OptionShimmer>
    </WrapperShimmer>
);